/**
 * EngineDetailIcon Component
 *
 * Engine-specific detail view for Icon Engine.
 * Delegates to IconAnalysisView with bare mode for per-card CollapsibleSections.
 */

import type { IconEngineSpecificAnalysis, AsoIconEngineResult } from "@a7y/types";
import { IconAnalysisView } from "@/components/audit/icon/IconAnalysisView";

export interface EngineDetailIconProps {
  /** Icon-specific analysis data */
  analysis: IconEngineSpecificAnalysis;
  /** When true, force-expands all collapsible sections (for print/PDF) */
  printMode?: boolean;
  /** Additional CSS classes */
  className?: string;
}

export function EngineDetailIcon({ analysis, printMode, className = "" }: EngineDetailIconProps) {
  // Cast analysis to AsoIconEngineResult since IconEngineSpecificAnalysis is
  // Omit<AsoIconEngineResult, "createdAt" | "version" | "crc" | "unified_output" | "cost">
  // which has all the fields needed for display
  return (
    <div className={className}>
      <IconAnalysisView
        icon={analysis as unknown as AsoIconEngineResult}
        iconUrl={analysis.icon_url_cached}
        bare
        printMode={printMode}
      />
    </div>
  );
}
